var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdogwuDownBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 181,
    viewBox: "0 0 476 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_3112_53079)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10.6716,
    width: 454.565,
    height: 154.199,
    rx: 3.41206,
    fill: "url(#paint0_linear_3112_53079)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5.67157,
    width: 464.565,
    height: 164.199,
    rx: 8.41206,
    stroke: "url(#paint1_linear_3112_53079)",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_3112_53079",
    x: 0.79428,
    y: 0.67157,
    width: 476.212,
    height: 179.342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.93736
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.10286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.447059 0 0 0 0 0.152941 0 0 0 0 0.00392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3112_53079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3112_53079",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.23432,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_3112_53079"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.8549,
    dy: 13.226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.10286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4625 0 0 0 0 0.186127 0 0 0 0 0.00770833 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_3112_53079"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3112_53079",
    x1: 238.282,
    y1: 10.6716,
    x2: 240.074,
    y2: 164.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#9B4605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E2401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3112_53079",
    x1: 344.268,
    y1: 20.55,
    x2: 258.906,
    y2: 193.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D17B0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52422,
    stopColor: "#FCA22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728844,
    stopColor: "#CD7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#973E04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdogwuDownBg);
export default __webpack_public_path__ + "static/media/odogwu-down-bg.7c054e9b3ea2939abaa7cfbe16d62b0d.svg";
export { ForwardRef as ReactComponent };